import { Div } from '@codesuma/baseline'
import { SheetPage } from '../../components/sheet-page'
import { MenuItem } from './menu-item'
import { APP_VERSION } from '../../configs/app'
import widget from '../../services/widget'
import rating from '../../services/rating'
import { toFaDigits } from '../../helpers/digits'
import { Settings } from './settings'
import style from './index.module.css'

// The app menu (slides up from the home page): navigation to the date
// converter, the prices — the way back to them once the ticker is emptied —
// the country holidays directory, and the About, Privacy and
// Contact pages, then the settings under their own heading, and the version
// in the footer.
export const MenuPage = () => {
    const base = SheetPage('تقویم فارسی امروز')

    const list = Div()
    list.addClass(style.list)
    list.append(
        MenuItem('تبدیل تاریخ', '/converter'),
        MenuItem('قیمت ارز و طلا', '/rates'),
        MenuItem('تعطیلات و رویدادهای کشورها', '/countries'),
        // Native only: a browser has no home screen to put a card on.
        ...(widget.available() ? [MenuItem('ویجت صفحهٔ خانه', '/widget')] : []),
        MenuItem('دربارهٔ امروز', '/about'),
        MenuItem('حریم خصوصی', '/privacy'),
        MenuItem('تماس با ما', '/contact'),
        // Native only: opens the store's review page.
        ...(rating.available() ? [MenuItem('امتیاز دادن به امروز', rating.open)] : []),
    )
    base.append(list)

    const heading = Div('تنظیمات')
    heading.addClass(style.heading)

    // The router keeps this page, so a return from the device's own settings
    // arrives as an enter and not as a fresh build.
    const settings = Settings()
    base.on('enter', settings.refresh)
    list.append(heading, settings)

    const footer = Div(`نسخهٔ ${toFaDigits(APP_VERSION)}`)
    footer.addClass(style.footer)
    list.append(footer)

    return base
}
